/* eslint-disable max-len */
import BaseController from './oversight.base.controller';

export default function OversightController(
  $filter,
  $location,
  $q,
  $rootScope,
  $scope,
  alerts,
  loaderService,
  orgDataService,
  serviceIds,
  oversightSettingsDialog,
  ssDialogService,
  userService,
  oversightDataService,
  oversightSharedModelService,
  editAgendaDialog,
) {
  BaseController.call(this, userService, loaderService);
  this.initPermissions();
  const vm = this;

  vm.eulaAccepted = true;
  vm.appIsLoaded = false;
  vm.customerId = 0;
  vm.groupId = 50;

  vm.handleShowSettings = handleShowSettings;
  vm.handleShowAddAgenda = _handleShowAddAgenda;

  _activate();

  /** ***************************************************
   * Event Handlers
   */

  function handleShowSettings($event) {
    loaderService.showViewLoader = true;
    return oversightDataService.getSettings().then((response) => {
      loaderService.showViewLoader = false;
      ssDialogService.dialogs.oversight.settingsDialog = ssDialogService.alert(
        oversightSettingsDialog.getOptions($event, {
          settings: response.data,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.oversight.settingsDialog);
    });
  }

  function _handleShowAddAgenda($event) {
    loaderService.showViewLoader = true;
    return _refreshAgendaTypes().then(() => _refreshUsers().then(() => {
      loaderService.showViewLoader = false;
      // Display new agenda dialog
      ssDialogService.dialogs.oversight.editAgendaDialog = ssDialogService.alert(
        editAgendaDialog.getOptions($event, {
          agenda: {
            agendaId: 0,
            agendaTypeId: null,
            isActive: true,
            startDate: null,
            endDate: null,
            agendaTemplateId: null,
          },
          agendaTypes: vm.agendaTypes,
          coordinators: vm.coordinators,
          refreshAgenda: false,
        })
      );
      return ssDialogService.show(ssDialogService.dialogs.oversight.editAgendaDialog);
    }));
  }

  /** ***************************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    _initDocumentManagement();

    userService.getUser(false).then((user) => {
      vm.customerId = user.customerId;
    });

    _initPage().then(() => {
      vm.eulaAccepted = true;
      vm.appIsLoaded = true;
      loaderService.showViewLoader = false;
    });
  }
  // eslint-disable-next-line
  function _initPage() {
    return oversightDataService.initOversight().then((getOversightInitResponse) => {
      if (getOversightInitResponse.data.AgendaItemStatuses) {
        vm.agendaItemStatuses = getOversightInitResponse.data.AgendaItemStatuses.result;
        oversightSharedModelService.agendaItemStatuses = vm.agendaItemStatuses;
      }

      if (getOversightInitResponse.data.ScheduleTypes) {
        vm.scheduleTypes = getOversightInitResponse.data.ScheduleTypes.result;
        oversightSharedModelService.ScheduleTypes = vm.scheduleTypes;
      }

      // _refreshUsers(),
      if (getOversightInitResponse.data.Coordinators) {
        vm.coordinators = getOversightInitResponse.data.Coordinators.result;
        oversightSharedModelService.coordinators = vm.coordinators;
      }

      if (getOversightInitResponse.data.ApplicationUsers) {
        vm.applicationUsers = getOversightInitResponse.data.ApplicationUsers.result;
        oversightSharedModelService.applicationUsers = vm.applicationUsers;
      }
      if (getOversightInitResponse.data.Agendas) {
        vm.agendas = getOversightInitResponse.data.Agendas.result;
        vm.activeAgendas = $filter('filter')(vm.agendas, { isActive: true });
        vm.completedAgendas = $filter('filter')(vm.agendas, { isActive: false });
        $rootScope.latestCompletedAgenda = $filter('orderBy')(vm.completedAgendas, 'name', true)[0];
      }

      if (getOversightInitResponse.data.AgendaTypes) {
        vm.agendaTypes = getOversightInitResponse.data.AgendaTypes.result;
        oversightSharedModelService.agendaTypes = vm.agendaTypes;
      }
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshAgendas', _refreshAgendas);
    $scope.$on('refreshAgendaTypes', _refreshAgendaTypes);
    $scope.$on('refreshAgendaUsers', _refreshUsers);
  }

  function _initDocumentManagement() {
    vm.maxAttachments = 10; // TODO: set maxAttachments to business specs (10 is just a guess) or to value from api
  }

  function _refreshAgendas() {
    return oversightDataService.getAgendas().then((getAgendasResponse) => {
      vm.agendas = getAgendasResponse.data.result;
      vm.activeAgendas = $filter('filter')(vm.agendas, { isActive: true });
      vm.completedAgendas = $filter('filter')(vm.agendas, { isActive: false });
      $rootScope.latestCompletedAudit = $filter('orderBy')(vm.completedAgendas, 'name', true)[0];
    });
  }

  function _refreshAgendaTypes() {
    return oversightDataService.getAgendaTypes().then((response) => {
      vm.agendaTypes = response.data.result;
      oversightSharedModelService.agendaTypes = vm.agendaTypes;
    });
  }

  function _refreshUsers() {
    return orgDataService.getApplicationUsers().then((appUserResponse) => {
      vm.coordinators = appUserResponse.data.result;
      oversightSharedModelService.coordinators = vm.coordinators;

      orgDataService.getSelectableUsers().then((assignableUserResponse) => {
        vm.applicationUsers = assignableUserResponse.data.result;
        oversightSharedModelService.applicationUsers = vm.applicationUsers;
      });
    });
  }
}

OversightController.$inject = [
  '$filter',
  '$location',
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'loaderService',
  'orgDataService',
  'serviceIds',
  'oversightSettingsDialog',
  'ssDialogService',
  'userService',
  'oversightDataService',
  'oversightSharedModelService',
  'editAgendaDialog'
];
